// extracted by mini-css-extract-plugin
module.exports = {"contact_section":"Contact_contact_section__E_BUa","title":"Contact_title__wYFrQ"};